import { ApiClient } from '@listening/api-contract/api-client-tag';
import { ChapterDetail as ChapterDetailSchema } from '@listening/api-contract/schemas';
import { Effect } from 'effect';
import type { LegacyChapterChunkParams } from '../legacy-reader/chapter-chunks';

export type LegacyAudioChapterDetail = typeof ChapterDetailSchema.Type;

export type LegacyChapterChunkPage = {
  chapters: ReadonlyArray<LegacyAudioChapterDetail>;
  cursor: string | null;
};

export const listLegacyChapterChunkEffect = ({
  audioId,
  cursor,
  limit,
}: LegacyChapterChunkParams) =>
  Effect.flatMap(ApiClient, (api) =>
    api.Audio.ListChapters({
      params: { audioOrSlug: audioId },
      query: {
        ...(cursor ? { cursor } : {}),
        limit,
      },
    }),
  );
